import { CompanyShowType } from '@api';
import { formatDate, ShowTableCell, StatusBadge } from '@common';
import { DataTableColumn } from 'mantine-datatable';
import { useTranslation } from 'react-i18next';

export type UseCompanyShowsColumnsReturnType = {
  columns: DataTableColumn<CompanyShowType>[];
};

export const useCompanyShowsColumns = (): UseCompanyShowsColumnsReturnType => {
  const { t } = useTranslation('companyDetailsShows');

  const noDataPlaceholder = t('NO_DATA_PLACEHOLDER', { ns: 'common' });

  return {
    columns: [
      {
        accessor: 'showDate',
        title: t('COMPANY_SHOWS.TABLE.SHOW_DATE'),
        sortable: true,
        render: (record) => formatDate(record.showDate),
      },
      {
        accessor: 'showWithTour',
        title: t('COMPANY_SHOWS.TABLE.SHOW'),
        render: (record) => <ShowTableCell show={record.showWithTour} />,
      },
      {
        accessor: 'dealType',
        title: t('COMPANY_SHOWS.TABLE.DEAL_TYPE'),
        render: (record) => record.dealType ?? noDataPlaceholder,
      },
      {
        accessor: 'production',
        title: t('COMPANY_SHOWS.TABLE.PRODUCTION'),
        render: (record) => record.production ?? noDataPlaceholder,
      },
      {
        accessor: 'showSetup',
        title: t('COMPANY_SHOWS.TABLE.SHOW_SETUP'),
        render: (record) => record.showSetup ?? noDataPlaceholder,
      },
      {
        accessor: 'configuration',
        title: t('COMPANY_SHOWS.TABLE.CONFIGURATION'),
        render: (record) => record.configuration ?? noDataPlaceholder,
      },
      {
        accessor: 'status',
        title: t('COMPANY_SHOWS.TABLE.STATUS'),
        render: (record) => <StatusBadge status={record.status} />,
      },
    ],
  };
};
